import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'cookieConsent_v2';

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check cookie consent on mount
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Show banner after a short delay for better UX
      setTimeout(() => setIsVisible(true), 1000);

      // Set initial consent state for GTM
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'default_consent',
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied'
      });
    } else {
      // Apply stored consent
      const isAccepted = consent === 'accepted';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'consent_loaded',
        'ad_storage': isAccepted ? 'granted' : 'denied',
        'analytics_storage': isAccepted ? 'granted' : 'denied',
        'ad_user_data': isAccepted ? 'granted' : 'denied',
        'ad_personalization': isAccepted ? 'granted' : 'denied'
      });
    }
  }, []);

  // Handle consent choices
  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setIsVisible(false);

    // Update consent state via GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'consent_update',
      'ad_storage': 'granted',
      'analytics_storage': 'granted',
      'ad_user_data': 'granted',
      'ad_personalization': 'granted'
    });
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setIsVisible(false);

    // Keep tracking disabled via GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'consent_update',
      'ad_storage': 'denied',
      'analytics_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied'
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 p-4">
      <div className="container mx-auto max-w-6xl flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-gray-700 text-sm md:text-base">
          <p>
            Wir verwenden Cookies und Tracking-Technologien, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten.
            Einige sind für den Betrieb der Seite notwendig, während andere uns helfen,
            die Website und Ihr Nutzererlebnis zu verbessern sowie für Marketing-Zwecke (Google Analytics, Google Ads über Google Tag Manager).
          </p>
          <p className="mt-2">
            <Link 
              to="/datenschutz" 
              className="text-blue-600 hover:text-blue-800 underline"
            >
              Weitere Informationen in unserer Datenschutzerklärung
            </Link>
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
          >
            Ablehnen
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-white bg-[#2574B5] hover:bg-blue-700 rounded-md transition-colors"
          >
            Alle akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;